export default __webpack_public_path__ + "static/ring4-673a0e84a3fb6aab482637d3f4dc609c.png";